import type { AppRoutes } from '@ms/yammer-page-route-telemetry';
import { threadRoutePath } from '@ms/yammer-web-support/dist/urls';

export const pageRoutes: AppRoutes = [
  {
    page: 'Configure',
    path: '/configure',
    exact: true,
    hero: ['teams_meeting_configure'],
    loader: () => import(/* webpackChunkName: "4-page-configure" */ 'pages/PageConfigure'),
  },
  {
    page: 'Thread',
    path: threadRoutePath,
    hero: ['thread', 'thread_deleted_or_private'],
    loader: () => import(/* webpackChunkName: "4-page-thread" */ 'pages/PageThread'),
    dataLoader: () =>
      import(/* webpackChunkName: "4-pagedata-thread" */ '@ms/yammer-data/dist/domains/threadLoad/getThreadLoader'),
  },
  {
    page: 'TeamsMeetingDismissed',
    path: '/teams-meeting/:teamsMeetingId/dismissed',
    hero: ['feed'],
    loader: () => import(/* webpackChunkName: "4-page-teams-meeting" */ 'pages/PageTeamsMeeting'),
  },
  {
    page: 'TeamsMeetingInReview',
    path: '/teams-meeting/:teamsMeetingId/in-review',
    hero: ['feed'],
    loader: () => import(/* webpackChunkName: "4-page-teams-meeting" */ 'pages/PageTeamsMeeting'),
  },
  {
    page: 'TeamsMeetingPublished',
    path: '/teams-meeting/:teamsMeetingId/published',
    hero: ['feed'],
    loader: () => import(/* webpackChunkName: "4-page-teams-meeting" */ 'pages/PageTeamsMeeting'),
  },
  {
    page: 'TeamsMeeting',
    path: '/teams-meeting/:teamsMeetingId',
    hero: ['feed', 'content_inaccessible'],
    loader: () => import(/* webpackChunkName: "4-page-teams-meeting" */ 'pages/PageTeamsMeeting'),
  },
];
